module.exports = __webpack_public_path__ + "img/logo-header.b528a29a.png";